/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const InlineFeedbackOnQuizzesEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('INLINE_FEEDBACK_ON_QUIZZES_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class InlineFeedbackOnQuizzesEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return InlineFeedbackOnQuizzesEnabledSettingParser.decode(input).map(res => new InlineFeedbackOnQuizzesEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return InlineFeedbackOnQuizzesEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return InlineFeedbackOnQuizzesEnabledSettingParser.encode(data);
    }
    static schema() {
        return InlineFeedbackOnQuizzesEnabledSettingParser.schema();
    }
}
